import React from "react";
import {computeDocumentTitle} from "./ArticleView";

export function ArticleMetaTags({article}) {
    return <>
        <meta name="description"
              content={`${article.title} - A self-customizing article written by Bradley Arsenault on Articulon.`}/>
        <meta property="og:title" content={computeDocumentTitle(article)}/>
        <meta property="og:image" content="/logo1024.webp" />
        <meta property="og:type" content="article"/>
        <meta property="og:url" content={`https://articulon.bradleyarsenault.me/article/${article.slug}`}/>
    </>;
}